export default __webpack_public_path__ + "static/mediaCharTwo-7d983a4156cd99c74f1e953c4e6d09b4.png";